"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var browserify_aes_1 = tslib_1.__importDefault(require("browserify-aes"));

var randombytes_1 = tslib_1.__importDefault(require("randombytes"));

var util_1 = require("util");

var uuid_1 = tslib_1.__importDefault(require("uuid"));

var _1 = require(".");

function decrypt(_x, _x2) {
  return _decrypt.apply(this, arguments);
}

function _decrypt() {
  _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(v3Keystore, password) {
    var nonStrict,
        json,
        derivedKey,
        _json$crypto$kdfparam,
        n,
        r,
        p,
        dklen,
        salt,
        _json$crypto$kdfparam2,
        prf,
        c,
        _dklen,
        _salt,
        ciphertext,
        mac,
        iv,
        aesKey,
        decipher,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            nonStrict = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;

            if (util_1.isString(password)) {
              _context.next = 3;
              break;
            }

            throw new Error('No password given.');

          case 3:
            json = !util_1.isString(v3Keystore) ? v3Keystore : JSON.parse(nonStrict ? v3Keystore.toLowerCase() : v3Keystore);

            if (!(json.version !== 3)) {
              _context.next = 6;
              break;
            }

            throw new Error('Not a valid V3 wallet');

          case 6:
            if (!(json.crypto.kdf === 'scrypt')) {
              _context.next = 13;
              break;
            }

            _json$crypto$kdfparam = json.crypto.kdfparams, n = _json$crypto$kdfparam.n, r = _json$crypto$kdfparam.r, p = _json$crypto$kdfparam.p, dklen = _json$crypto$kdfparam.dklen, salt = _json$crypto$kdfparam.salt;
            _context.next = 10;
            return _1.scrypt(Buffer.from(password), Buffer.from(salt, 'hex'), n, r, p, dklen);

          case 10:
            derivedKey = _context.sent;
            _context.next = 23;
            break;

          case 13:
            if (!(json.crypto.kdf === 'pbkdf2')) {
              _context.next = 22;
              break;
            }

            _json$crypto$kdfparam2 = json.crypto.kdfparams, prf = _json$crypto$kdfparam2.prf, c = _json$crypto$kdfparam2.c, _dklen = _json$crypto$kdfparam2.dklen, _salt = _json$crypto$kdfparam2.salt;

            if (!(prf !== 'hmac-sha256')) {
              _context.next = 17;
              break;
            }

            throw new Error('Unsupported parameters to PBKDF2');

          case 17:
            _context.next = 19;
            return _1.pbkdf2(Buffer.from(password), Buffer.from(_salt, 'hex'), c, _dklen);

          case 19:
            derivedKey = _context.sent;
            _context.next = 23;
            break;

          case 22:
            throw new Error('Unsupported key derivation scheme');

          case 23:
            ciphertext = Buffer.from(json.crypto.ciphertext, 'hex');
            mac = _1.sha3(Buffer.concat([derivedKey.slice(16, 32), ciphertext])).replace('0x', '');

            if (!(mac !== json.crypto.mac)) {
              _context.next = 27;
              break;
            }

            throw new Error('Key derivation failed - possibly wrong password');

          case 27:
            iv = Buffer.from(json.crypto.cipherparams.iv, 'hex');
            aesKey = derivedKey.slice(0, 16);
            decipher = browserify_aes_1.default.createDecipheriv(json.crypto.cipher, aesKey, iv);
            return _context.abrupt("return", Buffer.concat([decipher.update(ciphertext), decipher.final()]));

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _decrypt.apply(this, arguments);
}

exports.decrypt = decrypt;

function encrypt(_x3, _x4, _x5) {
  return _encrypt.apply(this, arguments);
}

function _encrypt() {
  _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(privateKey, address, password) {
    var options,
        cipherAlgo,
        salt,
        iv,
        kdf,
        id,
        derivedKey,
        kdfparams,
        _options$c,
        c,
        _options$dklen,
        dklen,
        _options$n,
        n,
        _options$r,
        r,
        _options$p,
        p,
        _options$dklen2,
        _dklen2,
        aesKey,
        cipher,
        ciphertext,
        mac,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
            cipherAlgo = options.cipher || 'aes-128-ctr';
            salt = options.salt ? Buffer.from(options.salt, 'hex') : randombytes_1.default(32);
            iv = options.iv ? Buffer.from(options.iv, 'hex') : randombytes_1.default(16);
            kdf = options.kdf || 'scrypt';
            id = options.id || uuid_1.default.v4({
              random: options.uuid || randombytes_1.default(16)
            });

            if (!(cipherAlgo !== 'aes-128-ctr')) {
              _context2.next = 8;
              break;
            }

            throw new Error('Unsupported cipher');

          case 8:
            if (!(kdf === 'pbkdf2')) {
              _context2.next = 16;
              break;
            }

            _options$c = options.c, c = _options$c === void 0 ? 262144 : _options$c, _options$dklen = options.dklen, dklen = _options$dklen === void 0 ? 32 : _options$dklen;
            _context2.next = 12;
            return _1.pbkdf2(Buffer.from(password), salt, c, dklen);

          case 12:
            derivedKey = _context2.sent;
            kdfparams = {
              c: c,
              dklen: dklen,
              prf: 'hmac-sha256',
              salt: salt.toString('hex')
            };
            _context2.next = 25;
            break;

          case 16:
            if (!(kdf === 'scrypt')) {
              _context2.next = 24;
              break;
            }

            _options$n = options.n, n = _options$n === void 0 ? 8192 : _options$n, _options$r = options.r, r = _options$r === void 0 ? 8 : _options$r, _options$p = options.p, p = _options$p === void 0 ? 1 : _options$p, _options$dklen2 = options.dklen, _dklen2 = _options$dklen2 === void 0 ? 32 : _options$dklen2;
            _context2.next = 20;
            return _1.scrypt(Buffer.from(password), salt, n, r, p, _dklen2);

          case 20:
            derivedKey = _context2.sent;
            kdfparams = {
              n: n,
              r: r,
              p: p,
              dklen: _dklen2,
              salt: salt.toString('hex')
            };
            _context2.next = 25;
            break;

          case 24:
            throw new Error('Unsupported kdf');

          case 25:
            aesKey = derivedKey.slice(0, 16);
            cipher = browserify_aes_1.default.createCipheriv(cipherAlgo, aesKey, iv);

            if (cipher) {
              _context2.next = 29;
              break;
            }

            throw new Error('Unsupported cipher');

          case 29:
            ciphertext = Buffer.concat([cipher.update(privateKey), cipher.final()]);
            mac = _1.sha3(Buffer.concat([derivedKey.slice(16, 32), ciphertext])).replace('0x', '');
            return _context2.abrupt("return", {
              version: 3,
              id: id,
              address: address.toString().toLowerCase().replace('0x', ''),
              crypto: {
                ciphertext: ciphertext.toString('hex'),
                cipherparams: {
                  iv: iv.toString('hex')
                },
                cipher: 'aes-128-ctr',
                kdf: kdf,
                kdfparams: kdfparams,
                mac: mac.toString()
              }
            });

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _encrypt.apply(this, arguments);
}

exports.encrypt = encrypt;